import {
  WiDaySunny,
  WiDayCloudy,
  WiDayCloudyHigh,
  WiDayCloudyGusts,
  WiDayCloudyWindy,
  WiDayFog,
  WiDayHail,
  WiDayHaze,
  WiDayLightning,
  WiDayRain,
  WiDayRainMix,
  WiDayRainWind,
} from "react-icons/wi";

export function iconsForWeatherReactIcons(weather) {
  switch (weather) {
    case "Thunderstorm":
      return <WiDayLightning size={20} />;
    case "Drizzle":
      return <WiDayRainMix size={20} />;
    case "Rain":
      return <WiDayRain size={20} />;
    case "Snow":
      return <WiDayHail size={20} />;
    case "Atmosphere":
      return <WiDayHaze size={20} />;
    case "Clear":
      return <WiDaySunny size={20} />;
    case "Clouds":
      return <WiDayCloudy size={20} />;
    default:
      return <WiDaySunny size={20} />;
  }
}
